import * as React from 'react';
import { FIELD_TYPE } from 'app/infrastructure/simple-form';
import { FilterCommonProps } from '../types';
import { postfixOperator } from 'app/components/filters/filters-panel/constants';

export class FilterPredefinedFilters extends React.Component<FilterCommonProps, {}> {

  public render() {
    const { 
      simpleFormComponent: SimpleForm,
      translation,
      optionsParams,
      initialValue,
      filterDomain: { id: name }
    } = this.props;

    return <div>
      <h4>{translation.filters_include}</h4>
      <SimpleForm
        name={name + postfixOperator.include}
        type={FIELD_TYPE.SELECT_MULTIPLE_HIERARCHY}
        initialValue={initialValue && initialValue.include}
        optionsEndpoint={this.props.optionsEndpoint}
        placeholder={translation && translation.filters_search_placeholder}
        translation={translation}
        optionsParams={optionsParams} />
      <hr />
      <h4>{this.props.translation.filters_exclude}</h4>
      <SimpleForm
        name={name + postfixOperator.exclude}
        type={FIELD_TYPE.SELECT_MULTIPLE_HIERARCHY}
        initialValue={initialValue && initialValue.exclude}
        optionsEndpoint={this.props.optionsEndpoint}
        placeholder={translation && translation.filters_search_placeholder}
        translation={translation}
        optionsParams={optionsParams} />
    </div>;
  }
}
